import Image from 'gatsby-plugin-sanity-image';
import React from 'react';

import { BrandIcon } from '../brand-icon';
import { SystemIcon } from '../system-icon';
import * as styles from './marquee.module.css';

export function MarqueeItem({
	_key,
	brandIcon,
	displayText,
	image,
	itemDescription,
	itemTitle,
	itemType,
	systemIcon,
	svg,
}) {
	const displayIcon =
		itemType === 'brandIcon' ||
		itemType === 'svg' ||
		itemType === 'systemIcon';
	const displayImage = itemType === 'image';

	return (
		<div>
			{displayIcon && (
				<div className={styles.svgContainer} key={_key}>
					{itemType === 'brandIcon' && <BrandIcon icon={brandIcon} />}
					{itemType === 'systemIcon' && (
						<SystemIcon
							icon={systemIcon}
							iconColor={systemIcon.iconColor}
							iconSize={systemIcon.iconSize}
						/>
					)}
					{itemType === 'svg' && (
						<span dangerouslySetInnerHTML={{ __html: svg }} />
					)}
					{displayText && (
						<div className={styles.iconContainer}>
							{itemTitle && <p className='body-l'>{itemTitle}</p>}
							<p>{itemDescription}</p>
						</div>
					)}
				</div>
			)}
			{displayImage && (
				<div className={styles.imageContainer}>
					<Image {...image} alt={itemDescription} />
				</div>
			)}
		</div>
	);
}
